import { API_HOST, API_KEY, API_KEY_VALUE } from 'env-config';
import { EXPERIMENT_API } from '../constants/apis';
export function fetchExperiments(userId, region) {
    const apiUrl = `${API_HOST}${EXPERIMENT_API.END_POINT}${userId}?region=${region}`;
    return fetch(apiUrl, {
        method: EXPERIMENT_API.METHOD,
        headers: new Headers({
            'Content-Type': EXPERIMENT_API.CONTENT_TYPE,
            [API_KEY]: API_KEY_VALUE,
        }),
    });
}
//# sourceMappingURL=index.js.map